import useMediaQuery from '@mui/material/useMediaQuery';

export const useIsTouchDevice = (): boolean =>
  useMediaQuery('(hover: none), (pointer: coarse)');
